export default __webpack_public_path__ + "static/media/Neutre.a673e9ee.svg";